// extracted by mini-css-extract-plugin
module.exports = {"pay-btn":"PaymentsCard_pay-btn__2DFUN","pay_form":"PaymentsCard_pay_form__2sxll","pay_content":"PaymentsCard_pay_content__2xOoE"};